
<template>
	<div style="display: inline-block"  v-click-outside="closeOptions">
		<div class="bgChart" v-show="showOptions" @click="closeOptions"></div>
		<div class="pinFundsWrapper" >
			<div class="icon-search" @click="toggleOptions"></div>
			<div class="options" :class="showOptionsList">
				<div class="inputWrapper">
					<div class="inputTitle">Pinned Funds <span class="icon-rotate-cw" @click="resetPinnedFunds"></span></div>
					<multiselect
						class="funOptions"
						placeholder="Available Funds"
						label="title" track-by="title"
						:options="funds"
						:option-height="104"
						:show-labels="false"
						:close-on-select="false"
						@select="updatePinnedFunds">
						<template slot="singleLabel" slot-scope="props">
							<span class="option__desc"><span class="option__title">{{ props.option.title }}</span></span>
						</template>
						<template slot="option" slot-scope="props">
							<div class="option__icon">
								<img class="pinIcon" :src="props.option.icon"/>
							</div>
							<div class="option__desc">
								<div class="option__title">{{ props.option.title }}</div>
							</div>
						</template>
					</multiselect>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import vOutsideEvents from 'vue-outside-events';
import pushpin from '@/assets/svg/pushpin.svg';
import pushpinActive from '@/assets/svg/pushpinActive.svg';

Vue.use(vOutsideEvents);
export default {
    name: 'pinFunds',
    data () {
        return {
            showOptions: false,
            pushpin,
            pushpinActive,
        };
    },
    methods: {
        toggleOptions () {
            this.showOptions = !this.showOptions;
        },
        closeOptions () {
            this.showOptions = false;
        },
        activeIcon (Ticker) {
            return this.$store.state.user.pinnedFunds.findIndex(i => i === Ticker) > -1 ? this.pushpinActive : this.pushpin;
        },
        updatePinnedFunds (fund) {
            const result = this.$store.state.user.pinnedFunds.findIndex(i => i === fund.ticker);
            if (result > -1) {
                this.$store.commit('user/removePinnedFund', result);
            } else {
                this.$store.commit('user/addPinnedFund', fund.ticker);
            }
        },
        resetPinnedFunds () {
            this.$store.commit('user/resetPinnedFunds');
        },
    },
    computed: {
        funds () {
            function sorting (a, b) {
                const fundNameA = a.Name.toLowerCase();
                const fundNameB = b.Name.toLowerCase();
                let comp = 0;

                if (fundNameA > fundNameB) {
                    comp = 1;
                } else if (fundNameA < fundNameB) {
                    comp = -1;
                }
                return comp;
            }

            return this.$store.state.universe.data.allMetaData.slice(0).sort(sorting).map(i => ({ ticker: i.Ticker, title: i.Name, icon: this.activeIcon(i.Ticker) }));
        },
        showOptionsList () {
            return this.showOptions ? 'show' : '';
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import 'src/assets/scss/all.scss';
.bgChart {
    position: absolute;
    top:0;
    left:0%;
    right: 0;
    bottom: 0;
    z-index: 1;
}
.pinFundsWrapper {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    z-index: 2;
    .icon-search {
        color: $LCPMarine;
        cursor: pointer;
        font-size: 23px;
        vertical-align: middle;
		margin-left: 5px;
    }
    .options {
        -moz-border-radius: 0.4167rem;
        -ms-border-radius: 0.4167rem;
        -o-border-radius: 0.4167rem;
        -webkit-border-radius: 0.4167rem;
        background-color: white;
        border-radius: 0.4167rem;
        border: 2px solid $darkBlue;
        box-shadow: 0 9px 23px rgba(0, 0, 0, 0.09), 0 5px 5px rgba(0, 0, 0, 0.06) !important;
        display: none;
        padding:20px;
        position: absolute;
        right: 0px;
        top:50px;
        min-width: 500px;
        z-index: 1;
        @include easeInOut(0.5s);
        &:after, &:before {
            border: solid transparent;
            bottom: 100%;
            content: " ";
            height: 0;
            pointer-events: none;
            position: absolute;
            width: 0;
        }
        &:after {
            border-bottom-color:#FFFFFF;
            border-color: transparent;
            border-width: 10px;
            margin-left: -10px;
            right: 221px;
        }
        &:before {
            border-bottom-color: $darkBlue;
            border-color: transparent;
            border-width: 16px;
            margin-left: -16px;
            right: 215px;
        }
        &.show {
            display: block;
        }
        .inputWrapper{
            margin-top:15px;

            .multiselect{
                width: 100%;
            }
			.pinIcon {
				width: 10px;
			}
            &:first-child{
                margin-top:0;
            }

            .inputTitle {
                color: #002c5c;
                font-size: 14px;
                font-weight: 700;
                .icon-rotate-cw{
                    float:right;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.funOptions {
	.option {
		display: flex;
		.option__id {
			margin-top: 0px;
		}
	}
	.multiselect__option {
		display: flex;
		// justify-content: space-between;
	}
	.option__icon {
		margin-right: 10px;
		line-height: 15px;
	}
	.option__desc, .option__title {
		width: 400px;
		white-space: normal;
	}
}
</style>
